import React from 'react';
import styles from '../my-content.module.scss';
import { useMyContentContext } from '../my-content.context';
import { Skeleton } from 'antd';
import { formatNumber } from 'shared/utils';

export function TableStats() {
  const { totalItems, expiredCount, totalViews, lang, pageLoading } = useMyContentContext();

  const tableStats = React.useMemo(() => {
    const expiredPercentage = totalItems > 0 ? Math.round((expiredCount / totalItems) * 100) : 0;

    return {
      totalItems: formatNumber(totalItems),
      expiredItems: formatNumber(expiredCount),
      expiredPercentage,
      totalViews: formatNumber(totalViews),
    };
  }, [totalItems, expiredCount, totalViews]);

  if (pageLoading) {
    return <Skeleton.Input active size="large" style={{ width: '100%', marginBottom: 20 }} />;
  }

  return (
    <div className={styles.tableStats}>
      <span>
        <strong>{tableStats.totalItems}</strong> {lang.KNOWLEDGE_ITEMS}
      </span>
      <span>
        <strong>{tableStats.expiredPercentage}%</strong> {lang.EXPIRED}
      </span>
      <span>
        <strong>{tableStats.totalViews}</strong> {lang.TOTAL_KNOWLEDGE_VIEWS}
      </span>
    </div>
  );
}
